import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { filter, map, Subject, takeUntil } from 'rxjs';
import UserResponse from '../../interfaces/ip-user-response';
import { IpSupplierService } from '../../services/ip-supplier.service';

@Component({
  selector: 'app-ip-broker-input-select',
  templateUrl: './ip-broker-input-select.component.html',
  styleUrls: ['./ip-broker-input-select.component.scss']
})
export class IpBrokerInputSelectComponent implements OnInit, OnDestroy {
  @Input() control = new FormControl<number[]>([]);
  @Output() selectionChange = new EventEmitter<MatSelectChange>();

  brokers: UserResponse[] = [];
  filteredBroker: UserResponse[] = [];
  brokerFilter = new FormControl('');

  private _onDestroy = new Subject<void>();

  constructor(private readonly supplierService: IpSupplierService) {}

  ngOnInit(): void {
    this.supplierService.allBrokers$
      .pipe(
        filter((brokers) => brokers !== null),
        map((brokers) => brokers || [])
      )
      .subscribe({
        next: (value) => {
          this.brokers = value;
          this.filteredBroker = this.brokers.slice();
        },
        error: () => {
          console.error('Failed to get brokers');
        },
      });

    this.brokerFilter.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe((search) => {
        this.filteredBroker = this.filterBrokers(search ?? '');
      });
  }

  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  filterBrokers(search: string): UserResponse[] {
    if (!search) return this.brokers.slice();
    const lowerSearch = search.toLowerCase();
    return this.brokers.filter(
      (s) =>
        s.username.toLowerCase().includes(lowerSearch) ||
        s.fullName?.toLowerCase().includes(lowerSearch)
    );
  }

  onSelectionChange(event: MatSelectChange): void {
    this.selectionChange.emit(event);
  }
}
